import { render, staticRenderFns } from "./UserRepoNode.vue?vue&type=template&id=c9809406&scoped=true"
import script from "./UserRepoNode.vue?vue&type=script&lang=js"
export * from "./UserRepoNode.vue?vue&type=script&lang=js"
import style0 from "./UserRepoNode.vue?vue&type=style&index=0&id=c9809406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9809406",
  null
  
)

export default component.exports